// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GoogleSquareFilledSvg from "@ant-design/icons-svg/es/asn/GoogleSquareFilled";
import AntdIcon from '../components/AntdIcon';

var GoogleSquareFilled = function GoogleSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: GoogleSquareFilledSvg
  }));
};

GoogleSquareFilled.displayName = 'GoogleSquareFilled';
export default React.forwardRef(GoogleSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/GoogleSquareFilled.js
// module id = 1289
// module chunks = 0